export default __webpack_public_path__ + "static/media/card-blog16.858a2d56.jpg";